<template>
  <EditModal @close="close" @commit="commit" :lang="lang" class="modal-edit-user">
    <div class="modal-edit-user-input">
      <div class="modal-edit-user-input-title">{{lang.input.name}}</div>
      <BaseInput v-model="input.name" :placeholder="lang.input.name" :height="button.height" :width="button.width"></BaseInput>
    </div>
    <div class="modal-edit-user-input">
      <div class="modal-edit-user-input-title">{{lang.input.title}}</div>
      <BaseInput v-model="input.title" :placeholder="lang.input.title" :height="button.height" :width="button.width"
        icon="arrow_edit_open" iconFloat="right" @icon="showTitleDropdown=!showTitleDropdown"
      ></BaseInput>
      <BaseDropdown v-if="showTitleDropdown" class="modal-edit-user-input-dropdown"
        @close="showTitleDropdown=false"
        @click="updateTitle"
        :index="currentTitleIndex"
        :data="dataTitle"
      ></BaseDropdown>
    </div>
    <div class="modal-edit-user-input">
      <div class="modal-edit-user-input-title">{{lang.input.loc}}</div>
      <InputBlock :height="button.height" :width="button.width"
        icon="arrow_edit_open" iconFloat="right"
        @click="clickLocDropdownIcon"
      >
        <span class="modal-edit-user-input-value">{{input.province}}</span>
        <span class="modal-edit-user-input-value">{{input.city}}</span>
      </InputBlock>
      <BaseDropdown
        v-if="showLocDropDown" class="modal-edit-user-input-dropdown-province"
        @close="clickLocDropdownIcon"
        @click="updateProvince"
        :index="currentProvinceIndex"
        :data="dataProvince"
      ></BaseDropdown>
      <BaseDropdown
        v-if="showLocDropDown && currentProvinceIndex > -1" class="modal-edit-user-input-dropdown-city"
        @close="clickLocDropdownIcon"
        @click="updateCity"
        :index="currentCityIndex"
        :data="dataCity"
      ></BaseDropdown>
    </div>
  </EditModal>
</template>

<script>
import _ from 'lodash'
import { dcV2Graphql } from '@/api'

import EditModal from './EditModal.vue'

import { BaseInput } from '../input'
import { BaseDropdown } from '../dropdown'
import { InputBlock } from '../block'

export default {
  components: {
    EditModal,
    BaseInput,
    BaseDropdown,
    InputBlock
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    lang: {
      type: Object,
      default () {
        return {
          title: '编辑基本信息',
          input: {
            name: '姓名',
            title: '职称',
            loc: '城市'
          }
        }
      }
    }
  },
  data () {
    return {
      button: {
        height: '36px',
        width: '238px' // 240 - 2 (border)
      },
      input: {
        name: _.get(this.data, 'card.name'),
        title: _.get(this.data, 'card.title'),
        province: _.get(this.data, 'province'),
        city: _.get(this.data, 'city')
      },
      showTitleDropdown: false,
      showLocDropDown: false,
      currentTitleIndex: -1,
      currentProvinceIndex: -1,
      currentCityIndex: -1,
      dataTitle: [
        {value: 'CEO', label: 'CEO'},
        {value: 'CFO', label: 'CFO'},
        {value: 'CTO', label: 'CTO'}
      ],
      dataProvince: []
    }
  },
  computed: {
    dataCity () {
      let d = this.dataProvince[this.currentProvinceIndex].data
      if (d) {
        return d
      }
      return []
    }
  },
  methods: {
    close () { this.$emit('close') },
    commit () { this.$emit('commit', this.input) },
    updateTitle (row, i) {
      this.input.title = row.value
      this.currentTitleIndex = i
    },
    updateProvince (row, i) {
      this.input.province = row.value
      this.input.city = null
      this.currentProvinceIndex = i
      this.currentCityIndex = -1
    },
    updateCity (row, i) {
      this.input.city = row.value
      this.currentCityIndex = i
    },
    toggleIndex () {
      this.dataProvince.map((row, i) => {
        if (row.value === this.input.provice) {
          this.currentProvinceIndex = i
        }
        row.data.map((row, i) => {
          if (row.value === this.input.city) {
            this.currentCityIndex = i
          }
        })
      })
    },
    async clickLocDropdownIcon () {
      if (this.dataProvince.length <= 0) {
        this.dataProvince = await this.fetchProvinceCity()
      }
      this.toggleIndex()
      this.showLocDropDown = !this.showLocDropDown
    },
    async fetchProvinceCity () {
      let res = await dcV2Graphql.post('/', {
        query: `query Query { chinaProvinceCityData }`
      })
      let data = _.get(res, 'data.data.chinaProvinceCityData')
      let dataFixed = data.map((row, i) => {
        return {
          index: i,
          value: row.provinceName,
          label: row.provinceName,
          data: row.cityInfoList.map((row, i) => {
            return {
              index: i,
              label: row.name,
              value: row.name
            }
          })
        }
      })
      return dataFixed
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.modal-edit-user {
  padding: 15px 0;
  & .modal-edit-user-input {
    display: inline-block;
    margin: 0 30px;
    padding: 10px 0;
    & .modal-edit-user-input-title {
      color: var(--colorGray0);
      padding-bottom: 8px;
    }
    & .modal-edit-user-input-value {
      margin: 10px 3px;
      display: inline-block;
    }
    & .modal-edit-user-input-dropdown {
      background-color: var(--colorWhite);
      position: absolute;
      width: 236px;
    }
    & .modal-edit-user-input-dropdown-province {
      background-color: var(--colorWhite);
      position: absolute;
      width: 104px;
    }
    & .modal-edit-user-input-dropdown-city {
      background-color: var(--colorWhite);
      position: absolute;
      margin-left: 104px;
      width: 132px; /* 236 - 104 */
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/EditUserModal.vue